import React, { Component } from "react";
import ReactModal from "react-modal";
import { Form, Button, Modal } from "react-bootstrap";
import axios from "axios";
import { GetEmailData, GetData, SendLink } from "../../../api";
import Loader from "../../loader/loader";
import ReCAPTCHA from "react-google-recaptcha";
import config from "../../../config";

const GOOGLE_CAPTCHA = config.paymentcloud.GOOGLE_CAPTCHA;
export default class SendLinkMerchant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: "",
            modalLoader: false,
            note: "",
            emailSent: false,
            emailText: "",
            agent_name: "",
            organisation_name: "",
            dba_name: "Merchant",
            clickable: false,
            showOther: false,
            showDropDown: true,
            emails: [],
            captchaToken: "",
            captchaError: "",
        };
    }

    componentDidMount() {
        this.setState({ modalLoader: true });
        // Merge the two requests.
        axios
            .all([
                GetEmailData(this.props.editSlug),
                GetData(this.props.editSlug),
            ])
            .then((resp) => {
                const email_data_response = resp[0];
                const response = resp[1];
                let dba_name =
                    email_data_response.data &&
                    email_data_response.data.dba_name
                        ? email_data_response.data.dba_name
                        : "Merchant";
                let agent_name =
                    email_data_response.data &&
                    email_data_response.data.agent_name
                        ? email_data_response.data.agent_name
                        : "Agent Name";
                let organisation_name =
                    email_data_response.data &&
                    email_data_response.data.organisation_name
                        ? email_data_response.data.organisation_name
                        : "Organization Name";

                let emails = [];
                let field_businessemail =
                    response.data && response.data.field_businessemail
                        ? response.data.field_businessemail
                        : null;
                let field_email =
                    response.data && response.data.field_email
                        ? response.data.field_email
                        : null;
                if (field_businessemail) {
                    emails.push(field_businessemail);
                }

                if (field_email) {
                    emails.push(field_email);
                }

                const showDropDown = emails.length > 0;
                const showOther = emails.length == 0;
                this.setState({
                    showDropDown: showDropDown,
                    showOther: showOther,
                    emails: [...emails, "Other"],
                    modalLoader: false,
                    note: `Dear ${dba_name}, ${agent_name} from ${organisation_name} has started a merchant services application on your behalf and has sent you the link below to review and complete. Please click and fill in the remaining fields to finish up your portion of the application process!`,
                });
            })
            .catch((err) => {
                this.setState({
                    modalLoader: false,
                    emailText: "Something went wrong. Try again later.",
                });
            });
    }

    handleSend = () => {
        this.setState({
            modalLoader: true,
            emailText: "",
            captchaError: "",
        });

        SendLink({
            slug: this.props.editSlug,
            email: this.state.emailAddress,
            note: this.state.note,
            captchaToken: this.state.captchaToken,
        })
            .then((response) => {
                if (response.status) {
                    this.setState({
                        emailSent: true,
                        clickable: false,
                        emailText: "E-mail Sent Successfully.",
                    });

                    setTimeout(() => {
                        this.setState({
                            emailSent: false,
                            emailText: "",
                            clickable: true,
                            captchaToken: "",
                        });
                        this.props.toggleSendLinkModal(false);
                    }, 3000);
                } else {
                    this.setState({
                        emailText: "Something went wrong. Try again later.",
                    });

                    setTimeout(() => {
                        this.setState({
                            emailText: "",
                            captchaToken: "",
                        });
                    }, 3000);
                }
            })
            .catch((error) => {
                // Get the error response
                const errorResponse = JSON.parse(error.request.response);
                if (errorResponse.errors) {
                    if (errorResponse.errors && errorResponse.errors.email) {
                        this.setState({
                            emailText: errorResponse.errors.email[0],
                        });
                    } else if (
                        errorResponse.errors &&
                        errorResponse.errors.captchaToken
                    ) {
                        this.setState({
                            captchaError: "Please fill the captcha",
                        });
                    } else {
                        this.setState({
                            emailText: "Something went wrong. Try again later.",
                        });
                    }
                } else {
                    if (errorResponse.captchaMsg) {
                        this.setState({
                            captchaError: errorResponse.captchaMsg,
                        });
                    }
                    this.setState({
                        emailText: "Something went wrong. Try again later.",
                    });
                }
            })
            .finally(() => this.setState({ modalLoader: false }));
    };

    emailDropDownChangeHandler = (e) => {
        const emails = [...this.state.emails];

        const value = e.target.value;
        // If user is asking for the other then show the other
        if (e.target.value == "Other") {
            this.setState({
                showOther: true,
                emailAddress: "",
            });
        } else {
            this.setState({
                emailAddress: e.target.value,
                showOther: false,
            });
        }
    };

    captchaChange = (token) => {
        this.setState({
            captchaToken: token,
        });
    };

    handleExpire = () => {
        this.setState({
            captchaToken: null,
        });
    };

    render() {
        return (
            <ReactModal
                isOpen={this.props.showSendLinkModal}
                className="add-residue-modal Add-residual add-member-modal"
            >
                <Modal.Header>
                    <Modal.Title>Send link to Merchant</Modal.Title>
                </Modal.Header>
                {this.state.modalLoader ? (
                    <div>
                        <Loader />
                    </div>
                ) : (
                    <Modal.Body className="rounded-bottom">
                        <Form className="recapcha-area">
                            {this.state.emailText ? (
                                <small
                                    className={
                                        this.state.emailSent
                                            ? "text-success"
                                            : "text-danger"
                                    }
                                >
                                    <i className="fa fa-at-custom"></i> *{" "}
                                    {this.state.emailText}
                                </small>
                            ) : null}
                            {this.state.showDropDown ? (
                                <Form.Group>
                                    <Form.Control
                                        as="select"
                                        required={true}
                                        value={
                                            this.state.showOther
                                                ? "Other"
                                                : this.state.emailAddress
                                        }
                                        onChange={
                                            this.emailDropDownChangeHandler
                                        }
                                    >
                                        <option
                                            key={`digital-modal-by-default`}
                                            value={""}
                                            disabled={true}
                                        >
                                            {" "}
                                            Select The E-mail Address{" "}
                                        </option>

                                        {this.state.emails.map(
                                            (email, index) => (
                                                <option
                                                    key={`digital-modal-${index}`}
                                                    value={email}
                                                >
                                                    {" "}
                                                    {email}{" "}
                                                </option>
                                            ),
                                        )}
                                    </Form.Control>
                                </Form.Group>
                            ) : null}
                            <>
                                <Form.Group>
                                    {this.state.showOther ? (
                                        <Form.Control
                                            readOnly={this.state.emailSent}
                                            className="mb-4"
                                            onChange={(e) =>
                                                this.setState({
                                                    emailAddress:
                                                        e.target.value,
                                                })
                                            }
                                            type="email"
                                            placeholder="Email address to receive the link"
                                            ref="email"
                                        />
                                    ) : null}
                                </Form.Group>
                                <Form.Group>
                                    <Form.Control
                                        readOnly={
                                            this.state.emailSent ||
                                            !this.state.clickable
                                        }
                                        value={this.state.note}
                                        rows={5}
                                        as="textarea"
                                        placeholder="Enter the note you want to send"
                                        onChange={(e) =>
                                            this.setState({
                                                note: e.target.value,
                                            })
                                        }
                                        onClick={(e) =>
                                            this.setState({ clickable: true })
                                        }
                                        onBlur={(e) =>
                                            this.setState({ clickable: false })
                                        }
                                    ></Form.Control>
                                </Form.Group>
                                <span className="text-danger">
                                    <small>
                                        *{" "}
                                        {this.state.clickable
                                            ? "Please edit the text to your merchant."
                                            : "Please, Click here to edit the text to your merchant"}
                                        .
                                    </small>
                                </span>
                                {this.state.captchaError ? (
                                    <small
                                        className={
                                            this.state.captchaError
                                                ? "text-danger"
                                                : "text-danger"
                                        }
                                    >
                                        <i className="fa fa-at-custom"></i> *{" "}
                                        {this.state.captchaError}
                                    </small>
                                ) : null}
                                <Form.Group>
                                    <ReCAPTCHA
                                        sitekey={GOOGLE_CAPTCHA}
                                        onChange={this.captchaChange}
                                        onExpire={this.handleExpire}
                                        size="normal"
                                    />
                                </Form.Group>
                            </>
                            <Form.Group>
                                <Button
                                    className="cancelbtn"
                                    style={{ marginRight: "10px" }}
                                    onClick={() =>
                                        this.props.toggleSendLinkModal(false)
                                    }
                                >
                                    Cancel
                                </Button>
                                {!this.state.emailSent ? (
                                    <Button
                                        className="sendbtn"
                                        onClick={this.handleSend}
                                    >
                                        Send
                                    </Button>
                                ) : null}
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                )}
            </ReactModal>
        );
    }
}
